import Modal from './Modal.js';
import { splideInit, Mask, nextSliderAudio } from './Splide.js';

class Request {
	constructor() {
		this.init();
	}
	init() {
		this.links = [...document.querySelectorAll(`[data-request]`)];
		this.handleLinks();
	}
	handleLinks() {
		this.links.forEach(link => {
			link.addEventListener('click', async (e) => {
				e.preventDefault();

				document.body.classList.remove('modal-body', 'noscroll');
				
				nextSliderAudio.load();
				const data = link.getAttribute('data-request');
				if (data==='questions.ajax.html') {
					if (typeof(fbq)==='function') fbq('track', 'Lead',);
					if (typeof(ga)==='function') ga('send','event','Tlacitko','Kliknuti','00 Pripojit se',1);
				}

				let video;
				if (data==='share.ajax.html') {
					video = document.createElement("video");
					video.poster = "assets/img/share_video_poster.jpg";
					video.src = "assets/files/video.mp4";
					video.height = 1504;
					video.width = 1000;
					video.setAttribute('playsinline', 'playsinline')
					video.setAttribute('webkit-playsinline', 'webkit-playsinline')
					video.load();

					if (typeof(ga)==='function') ga('send','event','Tlacitko','Kliknuti','18 Pokracovat Konec',1);

				}

				if (data==='end.ajax.html' && typeof(ga)==='function') {
					ga('send','event','Tlacitko','Kliknuti','17 Pokracovat dal', 1);
				}

				await Mask.showOver();
				await this.request(data);

				if (document.querySelector('.video') && video) {
					document.querySelector('.video').innerHTML="";
					document.querySelector('.video').appendChild(video);
				}

				Mask.hideOver();

				await Mask.delay(100);

				let end_section = document.querySelector('.end');
				if (end_section) end_section.classList.add('end--show');

				await Mask.delay(650);
				

				if (video) video.play();
					
				

			}, false);
		});
	}

	async request(data) {
		await fetch(data)
			.then((response) => {
				return response.text();
			})
			.then((html) => {
				// document.body.innerHTML = html;
				document.getElementById('app').outerHTML = html;
				splideInit();
				const modal = new Modal();
				modal.onCreateContent = () => {this.init();};
				this.init();
			});
	}
}

export default Request;

let end_section = document.querySelector('.end');
if (end_section) end_section.classList.add('end--show');